import apiService from './api';
import { AccountHead, CreateAccountHead } from '../types/accountHeadTypes';

class AccountHeadService {
  async getAccountHeads(): Promise<AccountHead[]> {
    const response = await apiService.get<AccountHead[]>('/account-head');
    return response.data;
  }

  async createAccountHead(data: Partial<CreateAccountHead>): Promise<AccountHead> {
    const response = await apiService.post<AccountHead>('/account-head', data);
    return response.data;
  }

  async updateAccountHead(id: number, data: Partial<CreateAccountHead>): Promise<AccountHead> {
    const response = await apiService.put<AccountHead>(`/account-head/${id}`, data);
    return response.data;
  }

  async deleteAccountHead(id: number): Promise<void> {
    await apiService.delete(`/account-head/${id}`);
  }
}

export const accountHeadService = new AccountHeadService();
export default accountHeadService;
